var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M30.77 101.378h18.46V108H30.77z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M16.632 82C3.905 83.405-1.518 88.598.363 97.578c1.882 8.98 4.224 16.228 7.028 21.744 1.896.904 3.294.904 4.195 0 .9-.903.9-7.19 0-18.862-.522-4.719 2.796-6.787 9.952-6.205M63.368 82c12.727 1.405 18.15 6.598 16.269 15.578-1.882 8.98-4.224 16.228-7.028 21.744-1.896.904-3.294.904-4.195 0-.9-.903-.9-7.19 0-18.862.522-4.719-2.796-6.787-9.952-6.205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M34.844 2.428C36.806.809 38.539 0 40.04 0c.478 0 2.13.686 3.93 1.95C73.288 26.594 76.557 59.944 53.777 102H26.928C3.698 62.13 6.336 28.94 34.844 2.428z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M21.538 18c11.966 4 23.932 4 35.898 0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.487,
    cy: 41,
    fill: "#EB8181",
    rx: 10.769,
    ry: 11
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M31.27 101.878v5.622h17.46v-5.622H31.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M37.58 83.961c2.162-1.281 4.141-1.281 5.937 0 2.409 9.082 2.117 22.095-.876 39.039h-3.833c-3.416-20.546-3.825-33.56-1.228-39.039z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no-orders.8390e8da05e33859e44b6fb8e276280c.svg";
export { ForwardRef as ReactComponent };